"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.theme = void 0;

var _styles = require("@material-ui/core/styles");

require("fontsource-roboto/400.css");

require("fontsource-roboto/500.css");

var theme = {
  name: 'Saraiva',
  palette: {
    primary: {
      light: '#816AB1',
      main: '#624C92',
      dark: '#4E3C74'
    },
    secondary: {
      light: '#2E78C7',
      main: '#245A93',
      dark: '#1C4774'
    },
    error: {
      light: '#CD444B',
      main: '#A42C31',
      dark: '#822327'
    },
    warning: {
      light: '#BE5906',
      main: '#AE6427',
      dark: '#894F1F'
    },
    info: {
      light: '#6C55A0',
      main: '#624C92',
      dark: '#40325E'
    },
    success: {
      light: '#2DC08F',
      main: '#1F8563',
      dark: '#18684D'
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.38)'
    },
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      hover: 'rgba(0, 0, 0, 0.04)',
      selected: 'rgba(0, 0, 0, 0.08)',
      disabled: 'rgba(0, 0, 0, 0.26)',
      disabledBackground: 'rgba(0, 0, 0, 0.12)'
    },
    background: {
      default: '#fafafa',
      paper: '#fff'
    },
    divider: 'rgba(0, 0, 0, 0.12)'
  },
  shape: {
    borderRadius: 8
  },
  overrides: {
    MuiButton: {
      contained: {
        boxShadow: 'none'
      }
    },
    MuiCssBaseline: {
      '@global': {
        body: {
          fontFamily: 'Roboto, Helvica, sans-serif',
          fontWeight: 400
        }
      }
    }
  }
};
exports.theme = theme;

var _default = (0, _styles.createMuiTheme)(theme);

exports.default = _default;